function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7D7C97",
  fillRule: "nonzero",
  d: "M.09 19.205C.09 11.01 6.48 4.278 14.62 3.65V2.603h-2.924a1.218 1.218 0 0 1-1.236-1.227c0-.688.543-1.226 1.236-1.226h8.138c.693 0 1.236.538 1.236 1.226s-.543 1.227-1.236 1.227H17.09V3.65c3.014.239 5.757 1.286 8.048 2.961l1.356-1.346-.572-.568a1.221 1.221 0 0 1 0-1.735 1.244 1.244 0 0 1 1.748 0l2.863 2.841a1.221 1.221 0 0 1 0 1.735c-.241.24-.542.36-.874.36-.332 0-.633-.12-.874-.36l-.573-.568-1.236 1.227a15.5 15.5 0 0 1 4.582 11.008c0 8.616-7.053 15.616-15.734 15.616-8.68 0-15.734-7-15.734-15.616zM15.824 6.043c-7.324 0-13.292 5.893-13.292 13.192 0 7.27 5.968 13.192 13.292 13.192 7.325 0 13.292-5.923 13.292-13.192 0-7.27-5.967-13.192-13.292-13.192zm0 14.18c-.693 0-1.236-.54-1.236-1.197v-7.569c0-.688.543-1.226 1.236-1.226s1.236.538 1.236 1.226v6.312h4.039c.693 0 1.236.539 1.236 1.227 0 .688-.543 1.226-1.236 1.226h-5.275z"
});

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.bb890fc6.svg";
export { ForwardRef as ReactComponent };